module.exports = __webpack_public_path__ + "static/media/sea.3912bdc3.JPG";